export default "__VITE_ASSET__tM5FPiO$__"